export default __webpack_public_path__ + "static/media/dpdigital.7fb2bacf.png";